import { render, staticRenderFns } from "./GoodsMovementsDetailSelector.vue?vue&type=template&id=da43ac54&scoped=true&"
import script from "./GoodsMovementsDetailSelector.vue?vue&type=script&lang=ts&"
export * from "./GoodsMovementsDetailSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsMovementsDetailSelector.vue?vue&type=style&index=0&id=da43ac54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da43ac54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VIcon,VTextField,VTooltip})
